import { Graphics, Text } from 'pixi.js';
import { type System, ComponentStore } from '@ecs/world';
import type { CameraResource, DeathMarkerComponent, StageBounds, TransformComponent } from '@game/scenes/characterPrototype/types';

export type DeathMarkerSystemOptions = {
	boundsKey: string;
	textMargin: number;
	textYOffset: number;
};

export function createDeathMarkerSystem(
	deathMarkers: ComponentStore<DeathMarkerComponent>,
	transforms: ComponentStore<TransformComponent>,
	deathMarkerGraphics: ComponentStore<Graphics>,
	deathMarkerTexts: ComponentStore<Text>,
	options: DeathMarkerSystemOptions
): System {
	return ({ world }) => {
		const camera = world.getResource<CameraResource>('camera');
		const bounds = world.getResource<StageBounds>(options.boundsKey);
		const offsetY = camera ? camera.y : 0;

		deathMarkers.forEach((_marker, entity) => {
			const transform = transforms.get(entity);
			if (!transform) return;

			const isLeftSide = bounds ? transform.x < bounds.width / 2 : true;

			const graphic = deathMarkerGraphics.get(entity);
			if (graphic) {
				graphic.position.set(transform.x, transform.y - offsetY);
			}

			const text = deathMarkerTexts.get(entity);
			if (text && bounds) {
				// Text position with margin from screen edge
				const textX = isLeftSide ? options.textMargin : bounds.width - options.textMargin;
				text.position.set(textX, transform.y - offsetY + options.textYOffset);
			}
		});
	};
}


